import { AnyAction } from "redux";

function cacheQuery(cacheKey: string, value: unknown): AnyAction {
  return { type: "CACHE_QUERY", cacheKey, value };
}

const queryCacheActions = { cacheQuery };

export default queryCacheActions;
